package network

/**
 * Bandera global de bloqueo por versión desactualizada.
 * La actualiza VersionViewModel tras verificar config/minVersion. Los puntos de escritura
 * críticos del cliente (ej. crear reserva) la consultan para bloquear apps viejas y evitar
 * que escriban con un esquema obsoleto. El gate "duro" definitivo está en las Cloud Functions.
 */
object VersionGate {
    var bloqueado: Boolean = false
}
